import "leaflet/dist/leaflet.css";
import { MotionConfig } from "motion/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { loadStorefrontAppearance } from "./lib/load-storefront-appearance";
import { initOtel } from "@/lib/otel";
import "./globals.css";

initOtel();
void loadStorefrontAppearance();


ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename={import.meta.env.BASE_URL}>
    <MotionConfig reducedMotion="user">
      <App />
    </MotionConfig>
  </BrowserRouter>
);
